import { render } from "./RenewPage.vue?vue&type=template&id=99f5e4c8&scoped=true"
import script from "./RenewPage.vue?vue&type=script&lang=js"
export * from "./RenewPage.vue?vue&type=script&lang=js"

import "./RenewPage.vue?vue&type=style&index=0&id=99f5e4c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f5e4c8"]])

export default __exports__